/* eslint-disable */
import * as Types from '../../graphql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;

export const GetCitiesPaginatedDocument = gql`
    query GetCitiesPaginated($countryId: Int, $page: Int, $itemsPerPage: Int, $search: String) {
  countryGeo {
    citiesPaginated(
      countryId: $countryId
      page: $page
      itemsPerPage: $itemsPerPage
      search: $search
    ) {
      items {
        id
        name
      }
      totalCount
      currentPage
      itemsPerPage
      pageCount
    }
  }
}
    `;

/**
 * __useGetCitiesPaginatedQuery__
 *
 * To run a query within a React component, call `useGetCitiesPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCitiesPaginatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCitiesPaginatedQuery({
 *   variables: {
 *      countryId: // value for 'countryId'
 *      page: // value for 'page'
 *      itemsPerPage: // value for 'itemsPerPage'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetCitiesPaginatedQuery(baseOptions?: Apollo.QueryHookOptions<GetCitiesPaginatedQuery, GetCitiesPaginatedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCitiesPaginatedQuery, GetCitiesPaginatedQueryVariables>(GetCitiesPaginatedDocument, options);
      }
export function useGetCitiesPaginatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCitiesPaginatedQuery, GetCitiesPaginatedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCitiesPaginatedQuery, GetCitiesPaginatedQueryVariables>(GetCitiesPaginatedDocument, options);
        }
export function useGetCitiesPaginatedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCitiesPaginatedQuery, GetCitiesPaginatedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCitiesPaginatedQuery, GetCitiesPaginatedQueryVariables>(GetCitiesPaginatedDocument, options);
        }
export type GetCitiesPaginatedQueryHookResult = ReturnType<typeof useGetCitiesPaginatedQuery>;
export type GetCitiesPaginatedLazyQueryHookResult = ReturnType<typeof useGetCitiesPaginatedLazyQuery>;
export type GetCitiesPaginatedSuspenseQueryHookResult = ReturnType<typeof useGetCitiesPaginatedSuspenseQuery>;
export type GetCitiesPaginatedQueryResult = Apollo.QueryResult<GetCitiesPaginatedQuery, GetCitiesPaginatedQueryVariables>;
export type GetCitiesPaginatedQueryVariables = Types.Exact<{
  countryId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  page?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  itemsPerPage?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  search?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetCitiesPaginatedQuery = { __typename?: 'Query', countryGeo?: { __typename?: 'CountryGeoProxy', citiesPaginated?: { __typename?: 'CityPaginated', totalCount?: number | null, currentPage?: number | null, itemsPerPage?: number | null, pageCount?: string | null, items?: Array<{ __typename?: 'CityProxy', id: number, name: string }> | null } | null } | null };
